import { ITellerOperation } from "./TellerOperation"

export interface ITellerDayClosing {
    id: number,
    
    netAmount: number,
    cancelledAmount: number,
    countNet: number,
    countCancelled: number,
    countTotal: number,
    closingNote: string,
    closingWarning: string,

    netCashAmount: number,

    tellerOperations: ITellerOperation[],    

    closingDate: Date,
  }
  

  export const defaultTellerDayClosing : ITellerDayClosing = {
    id: 0,

    netAmount: 0,
    cancelledAmount: 0,
    countNet: 0,
    countCancelled: 0,
    countTotal: 0,
    closingNote: '',
    closingWarning: '',

    netCashAmount: 0,

    tellerOperations: [],    

    closingDate: new Date(),
  }

  export interface IDashboardTellerDayClosing {
    operationsByCategory: {schoolYearName: string, category: string, amount: number} [],
    operationsByMode: {mode: string, netAmount: number, cancelledAmount: number}[]
  }
  

  export interface ITellerDayClosingSearch {
    startDate: Date,
    endDate: Date,

    closingNote: string,
    closingWarning: string
  }